import { render, staticRenderFns } from "./red-packet-history.vue?vue&type=template&id=2cfd83e3&scoped=true"
import script from "./red-packet-history.vue?vue&type=script&lang=js"
export * from "./red-packet-history.vue?vue&type=script&lang=js"
import style0 from "./red-packet-history.vue?vue&type=style&index=0&id=2cfd83e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd83e3",
  null
  
)

export default component.exports